import React, { useState } from 'react'
import { Input, FormCustom } from '../../Components/Form/Form'

const TypeDocumentForm = ({ data, onSubmit, disablebSubmit, loadSubmit }) => {
    const [row, setRow] = useState({
        p_id_type_document: data.id_type_document,
        p_name_document: data.name_document,
        p_code_document: data.code_document
    })

    return <FormCustom dataSubmit={row} onSubmit={onSubmit} disablebSubmit={disablebSubmit} loadSubmit={loadSubmit}>
        <Input
            text="Descripción"
            placeholder="Descripción"
            classNameParent="col-12 mb-2"
            icon="far fa-comment-alt"
            required
            invalid="El campo es obligatorio."
            defaultValue={data.name_document}
            onChange={e => setRow({ ...row, p_name_document: e.currentTarget.value })}
            maxLength={150}
        />
        <Input
            text="Código"
            placeholder="Código"
            classNameParent="col-12 mb-2"
            icon="fas fa-code"
            required
            invalid="Formato incorrecto. Ej: ESP, ENG"
            defaultValue={data.code_document}
            onChange={e => setRow({ ...row, p_code_document: e.currentTarget.value })}
            maxLength={20}
        />
    </FormCustom>
}

TypeDocumentForm.defaultProps = {
    data: {
        id_type_document: '',
        name_document: '',
        code_document: ''
    },
    onSubmit: () => {},
    loadSubmit: false
}

export default TypeDocumentForm;